module.exports = __webpack_public_path__ + "static/media/prefeitura-uberlandia.4fe51afa.jpg";